window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */
window.$ = window.jQuery = require('jquery');
window.Tether = require('tether');
require('bootstrap');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.axios.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        if (error.response !== undefined) {
            if (
                401 === error.response.status ||
                403 === error.response.status
            ) {
                /*
                window.location = '/login';
                */
            }
        }

        return Promise.reject(error);
    },
);

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    // ignored
}

window.moment = require('moment');
window.moment.locale('en-GB');

window.numeral = require('numeral');
window.toastr = require('toastr');
window.swal = require('sweetalert2');



// WEBPACK FOOTER //
// ./resources/assets/js/bootstrap.js